// code: ["A", "B", "C", "B", "B", "A"],
// chip: ["마감재", "집기", "마네킨", "영상", "간판/로고", "설비/누수/소방", "전기/조명", "음향", "소도구", "기타"],

import moment from "moment";
import { useEffect, useState } from "react";
import { useAppSelector } from "src/store/actions/action";

// code: ["1201000", "1202000", "1203000", "1206000", "1207000", "1208000", "1204000", "1205000", "1209000"],
const typeJSON = {
  마감재: "1201000",
  집기: "1202000",
  마네킨: "1203000",
  영상: "1206000",
  "간판/로고": "1207000",
  "설비/누수/소방": "1208000",
  "전기/조명": "1204000",
  음향: "1205000",
  소도구: "1210000",
  기타: "1209000",
  백화점: "A",
  대리점: "B",
  직영점: "C",
  상설: "O",
  아울렛: "OL",
  // 팩토리는 "F" 다. 2022년부터 "B"(대리점) 로 번역돼 팩토리 칩이 대리점 목록을 냈다 (VMD-396).
  // "F" 는 백엔드 StoreType enum 에 없고 운영 데이터에도 해당 매장이 0곳이라 빈 목록이 정답이다.
  팩토리: "F",
  면세점: "ADF",
  "1개월": "1",
  "3개월": "3",
  "6개월": 6,
  "12개월": 12,
  최신순: "DESC",
  오래된순: "ASC",
  가나다순: "ASC",
  제목순: "ASC",
  별점높은순: "DESC",
  별점낮은순: "ASC",
  이행률높은순: "DESC",
  이행률낮은순: "ASC",
  접수중: "as_20",
  업체배정: "as_40",
  견적진행: "as_60",
  "A/S진행": "as_80",
  완료: "as_100",
  취소: "as_0",
  0: "as_0",
  20: "as_20",
  40: "as_40",
  60: "as_60",
  80: "as_80",
  100: "as_100",
  일반공지: "1301000",
  "마네킨 착장": "1302000",
  매장연출: "1303000",
  영상공지: "1304000",
  비주얼: "1305000",
  기타공지: "1306000",
};

const categoryGroup: any = {
  store: [],
  date: [],
  category: [],
  process: [],
  manageSort: "",
  page: 0,
  contents: "",
  asSort: "",
  newStore: "",
};

// 페이지 값이 숫자여서 다른 검색에 숫자가 있으면 안됨
// 값에 따라 array 배열 분기하여 등록
// typeSearchArray에 유형전체 데이터를 배열로 가지고옴
// contentsSearchString, sortSearchString, pageSearchNumber 요소 하나씩 가지고 옴
// pattern

const categoryGroupClass = (key: any, value: any) => {
  // console.log(key, value);
  // filter.insert_date=$btw:2022-03-02,2022-03-02&filter.storeTypeCode.code_id=$in:A,B&search=롯&sortBy=open_date:ASC
  //   let queryFilter = "";
  if (key) {
    //typeSearchArray
    if (key === "typeSearchArray") {
      if ("백화점_대리점_직영점_상설_아울렛_팩토리_면세점".indexOf(value) > -1) {
        //   queryFilter = "filter.storeTypeCode.code_id=$in:";
        categoryGroup.store.push(value);
      } else if (
        "마감재_집기_마네킨_영상_간판/로고_설비/누수/소방_전기/조명_음향_소도구_기타_일반공지_매장연출_마네킨 착장_영상공지_비주얼_기타공지".indexOf(value) > -1
      ) {
        //   queryFilter = "filter.cate_idx=$in:";
        categoryGroup.category.push(value);
      } else if (String(value).indexOf("개월") > -1) {
        //   queryFilter = "filter.insert_date=$btw:";
        categoryGroup.date.push(value);
      } else if (String(value) === "기간선택") {
        //   queryFilter = "filter.insert_date=$btw:";
        categoryGroup.date.push(value);
      } else if ("접수중_업체배정_견적진행_A/S진행_완료_취소".indexOf(value) > -1) {
        categoryGroup.process.push(value);
      }
    }
    // else if (key === "processSearchArray") {
    //   categoryGroup.process.push(value);
    // }
    else if (key === "contentsSearchString") {
      categoryGroup.contents = value;
    } else if (key === "sortSearchString") {
      categoryGroup.manageSort = value;
    } else if (key === "asSortSearchString") {
      categoryGroup.asSort = value;
    } else if (key === "pageSearchNumber") {
      categoryGroup.page = value;
    } else if (key === "newStoreSearchString") {
      categoryGroup.newStore = value;
    }
  }
};

const commaMark = (i: number, lastLength: number) => {
  let comma = "";
  if (i !== lastLength - 1) {
    comma = ",";
  }
  return comma;
};

const quaterTrans = (quaterValue: string) => {
  let returnQuater = "&";
  if (quaterValue === "?") {
    returnQuater = "&";
  } else if (quaterValue === "") {
    returnQuater = "?";
  }
  return returnQuater;
};

const urlReplace = (url: string) => {
  url = url.replace(/&/g, "%26").replace(/\+/g, "%2B");
  return url;
};

// 쿼리스트링 메인
const setQueryStringVerV2 = (params: any, searchStartDate?: string, searchEndDate?: string) => {
  // console.log(params);
  // 글로벌 변수를 초기화
  categoryGroup.store = [];
  categoryGroup.date = [];
  categoryGroup.category = [];
  categoryGroup.process = [];
  categoryGroup.manageSort = "";
  categoryGroup.asSort = "";
  categoryGroup.page = 0;
  categoryGroup.contents = "";
  categoryGroup.newStore = "";
  // JSON 데이터를 받아서 처리
  const objectToStrong = JSON.stringify(typeJSON);
  const stringToJSON = JSON.parse(objectToStrong);
  let returnString = "";
  let quater = "";

  Object.entries(params).map((object: any, index: number) => {
    const key = object[0];
    const mapObject = object[1];
    // 배열
    if (typeof mapObject === "object") {
      if (mapObject.length > 0) {
        for (let i = 0; i < mapObject.length; i++) {
          categoryGroupClass(key, mapObject[i]);
        }
      }
    }
    if (typeof mapObject === "string") {
      if (mapObject !== "") {
        categoryGroupClass(key, mapObject);
      }
    }
    if (typeof mapObject === "number") {
      if (mapObject !== 0) {
        categoryGroupClass(key, mapObject);
      }
    }
  });

  if (categoryGroup.store.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.store_type=$in:";
    for (let i = 0; i < categoryGroup.store.length; i++) {
      returnString += stringToJSON[categoryGroup.store[i]] + commaMark(i, categoryGroup.store.length);
      //   if(i === (categoryGroup.store.length-1)){
      //   }else{
      //     returnString += stringToJSON[categoryGroup.store[i]] + ",";
      //   }
    }
  }
  if (categoryGroup.category.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.cate_idx=$in:";
    for (let i = 0; i < categoryGroup.category.length; i++) {
      returnString += stringToJSON[categoryGroup.category[i]] + commaMark(i, categoryGroup.category.length);
    }
  }
  if (categoryGroup.date.length > 0) {
    quater = quaterTrans(quater);
    returnString += quater + "filter.insert_date=$btw:";
    for (let i = 0; i < categoryGroup.date.length; i++) {
      if (categoryGroup.date[i] === "기간선택") {
        console.log("searchStartDate===============", searchStartDate);
        returnString += searchStartDate + "," + searchEndDate;
      } else {
        const startDate = moment().subtract(stringToJSON[categoryGroup.date[i]], "month").format("YYYY-MM-DD");
        // nestJS btw조건은 = 조건 포함 안되어서 react에서 하루 추가하여 데이터를 찾는다
        const result = new Date();
        result.setDate(result.getDate() + 1);
        const endDate = moment(result).format("YYYY-MM-DD");
        returnString += startDate + "," + endDate;
      }
    }
  }
  if (categoryGroup.process.length > 0) {
    quater = quaterTrans(quater);
    // 취소건이 생기면서 필터링 변경
    // returnString += quater + "filter.progress=$in:";
    returnString += quater + "filter.search_progress=$in:";
    for (let i = 0; i < categoryGroup.process.length; i++) {
      returnString += stringToJSON[categoryGroup.process[i]] + commaMark(i, categoryGroup.process.length);
    }
  }

  if (categoryGroup.manageSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.manageSort) > -1) {
      returnString += quater + "sortBy=open_date:";
    } else if ("가나다순".indexOf(categoryGroup.manageSort) > -1) {
      returnString += quater + "sortBy=name:";
    } else if ("별점높은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.score:";
    } else if ("별점낮은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.score:";
    } else if ("이행률높은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.execute_rate:";
    } else if ("이행률낮은순".includes(categoryGroup.manageSort)) {
      returnString += quater + "sortBy=scoreData.execute_rate:";
    }
    returnString += stringToJSON[categoryGroup.manageSort];
  }

  if (categoryGroup.asSort !== "") {
    quater = quaterTrans(quater);
    if ("최신순_오래된순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=insert_date:";
    } else if ("가나다순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=contents:";
    } else if ("제목순".indexOf(categoryGroup.asSort) > -1) {
      returnString += quater + "sortBy=title:";
    }
    returnString += stringToJSON[categoryGroup.asSort];
  }

  if (categoryGroup.newStore !== "") {
    quater = quaterTrans(quater);

    returnString += quater + "newStore=" + categoryGroup.newStore;
  }

  if (categoryGroup.contents !== "") {
    quater = quaterTrans(quater);
    returnString += quater + "search=" + urlReplace(categoryGroup.contents);
  }

  returnString += "&limit=1000";
  return returnString;
};

export default setQueryStringVerV2;
